module.exports = __webpack_public_path__ + "img/medical-card-bg-1.dad16f48.png";